module.exports = __webpack_public_path__ + "static/section1-photo3-a177a2d85deedfa13ccc89f13704707a.png";